import React from 'react';

import cn from 'classnames';

import cls from './ImageDescription.module.css';

interface ImageDescriptionProps {
    classes?: string;
    description: string;
    author?: { name: string; avatarUrl: string };
}

export const ImageDescription = ({ classes, description, author }: ImageDescriptionProps) => (
    <div className={cn(cls.ImageDescription, [classes])}>
        <div className={cls.descriptionBody}>
            {description && <div className={cls.description}>{description}</div>}
            {author && (
                <div className={cls.author}>
                    <img src={author.avatarUrl} alt={author.name} className={cls.avatar} />
                    <div className={cls.authorName}>{author.name}</div>
                </div>
            )}
        </div>
    </div>
);
